import React, { forwardRef } from 'react';
import { Platform } from 'react-native';

import DefaultControls from './PlayerControlTypes/DefaultControls';
import TVControls from './PlayerControlTypes/TvControls';
import { PlayerControlsProps, PlayerControlsRef } from './types';

const PlayerControls = forwardRef<PlayerControlsRef, PlayerControlsProps>(
  (props, playerControlsRef) => {
    let Controls = DefaultControls;

    /** Todo: Platform.isTV check should be removed once tvshell passes in controlType */
    if (props.controlType === 'tv' || Platform.isTV) {
      Controls = TVControls;
    }

    return <Controls ref={playerControlsRef} {...props} />;
  }
);

export default PlayerControls;
